// WO-35: collection / wishlist items can be any product id: Pokemon cards (base1-4), other games' cards
// (ygo.lob-en001, ...) and sealed products (me5.etb, ygo.<sealed id>). `snapshot` is the item's card_data
// (or the looked-up product) with game_id / product_type when known.
import { isProductCardId } from './games';

export function itemKind(id, snapshot) {
  const type = snapshot?.product_type;
  if (type && type !== 'single') return 'sealed';
  if (isProductCardId(id)) return 'game-card';
  if (!type && String(id || '').includes('.')) return 'sealed';   // e.g. me5.etb (Pokemon sealed ids have no namespace)
  return 'pokemon-card';
}

export function itemHref(id, snapshot) {
  const enc = encodeURIComponent(id || '');
  return itemKind(id, snapshot) === 'sealed' ? `/product/${enc}` : `/card/${enc}`;
}
